import {mapActions, mapMutations} from "vuex";

export default {

    methods : {
        ...mapMutations({
            ui__setModalVisibility: 'ui/setModalVisibility',
            ui__updateModal       : 'ui/updateModal',
            ui__setModalContainer : 'ui/setModalContainer'
        }),
        ...mapActions({
            ui__openModalByName: 'ui/openModalByName',
            ui__openModal      : 'ui/openModal',
            ui__closeModal     : 'ui/closeModal',
            ui__showModal      : 'ui/showModal',
            ui__hideModal      : 'ui/hideModal',
            ui__focusModal     : 'ui/focusModal'
        }),

    },
    computed: {
        ui__modals() {
            return this.$store.state.ui.modals
        }
    }
}
